import "./Details.css";
import plant from "../assets/det.jpeg";

function Details() {
    return (
        <section className="details-section" id="details">
            <div className="details-container">

                <h1 className="details-heading">
                    Plants and fresh air
                    <br />
                    has a place for everyone
                </h1>

                <div className="details-top">

                    <div className="details-image">
                        <img src={plant} alt="Plants" />
                    </div>

                    <div className="details-right">
                        <p>
                            We believe that everyone
                            deserves a clean environment enhanced with greeneries
                        </p>

                        <button>Learn More</button>
                    </div>

                </div>

                <div className="details-cards">

                    <div className="card">
                        <h2>
                            A community of
                            trusted plants with
                            no artificial moderation
                        </h2>

                        <p>
                            Highlight a specific plant can be a proper way to make place better
                            or something uniquely yours.
                            Give it room to shine here and there.
                        </p>
                    </div>

                    <div className="card">
                        <h2>
                            variety of plants available ranging from herbal to tree saplings
                        </h2>

                        <p>
                            The nursery functions as a comprehensive green resource center that supports plants for personal, local sustainable landscaping, and decoration
                        </p>
                    </div>

                    <div className="card">
                        <h2>
                            A pleasant
                            browsing experience
                        </h2>

                        <p>
                            The browsing space is designed as a comfortable and immersive area where visitors can freely walk through and explore a wide variety of plants and gardening displays.
                        </p>
                    </div>

                </div>

            </div>
        </section>
    );
}

export default Details;